module.exports = __webpack_public_path__ + "static/img/1000000473_green.89ad1764.jpg";